import React from "react";

const fmtTime12 = (v) => {
  const s = String(v || "");
  // Handles "YYYY-MM-DD HH:MM:SS" or ISO "YYYY-MM-DDTHH:MM:SS"
  const t = s.includes("T") ? s.split("T")[1] : (s.includes(" ") ? s.split(" ")[1] : s);
  const hhmm = String(t || "").slice(0,5);
  if (!/^[0-2][0-9]:[0-5][0-9]$/.test(hhmm)) return hhmm || "";
  let h = Number(hhmm.slice(0,2));
  const m = hhmm.slice(3,5);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12; if (h === 0) h = 12;
  return `${h}:${m} ${ampm}`;
};


const CalendarWeekView = ({
  isMobile,
  weekDays,
  apptsByDate,
  todayYMD,
  openNewForDate,
  openDayForDate,
  openEdit,
  fmtYMD,
  fmtFriendly,
  weekStart,
  styles,
}) => (
  <div className="jf-calendar-week-board" style={{ ...styles.board, ...(isMobile ? { borderLeftWidth: 0, borderRightWidth: 0, paddingLeft: 0, paddingRight: 0, marginLeft: -14, marginRight: -14, width: "calc(100% + 28px)", borderRadius: 0 } : {}) }}>
    <style>{`
      @media (max-width: 767px) {
        .jf-calendar-week-board {
          margin-left: -6px !important;
          margin-right: -6px !important;
          width: calc(100% + 12px) !important;
          padding-left: 5px !important;
          padding-right: 5px !important;
        }
      }
    `}</style>
    <div style={{ ...styles.boardInner, ...(isMobile ? { paddingLeft: 4, paddingRight: 4 } : {}) }}>
      <div style={{ fontWeight: 900, marginBottom: 10 }}>Week of {fmtFriendly(weekStart)} (Sun–Sat)</div>

      <div style={styles.weekScroll}>
        <div style={{ ...styles.weekGrid, ...(isMobile ? { gap: 2, minWidth: "100%" } : {}) }}>
          {weekDays.map((d) => {
            const key = fmtYMD(d);
            const list = apptsByDate[key] || [];
            const spanList = list.filter((a) => a.isMultiDay);
            const regularList = list.filter((a) => !a.isMultiDay);
            const isToday = key === todayYMD;

            return (
              <div key={key} style={{ ...styles.dayCol, display: "flex", flexDirection: "column", ...(isMobile ? { borderWidth: 2, borderRadius: 8 } : {}) }}>
                <div style={{ ...styles.dayColHeader(isToday), ...(isMobile ? { padding: "4px 1px", borderBottomWidth: 2, justifyContent: "center", fontSize: 12 } : {}) }}>
                  <button
                    type="button"
                    aria-label={`Open day ${key}`}
                    style={{ minWidth: 0, width: "100%", overflow: "visible", whiteSpace: "normal", border: 0, padding: 0, background: "transparent", color: "inherit", font: "inherit", fontWeight: 900, fontSize: isMobile ? 10 : undefined, lineHeight: 1.1, cursor: "pointer", textAlign: "center" }}
                    onMouseEnter={(e) => { e.currentTarget.style.textDecoration = "underline"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.textDecoration = "none"; }}
                    onClick={() => openDayForDate(d)}
                  >
                    {isMobile
                      ? <>{["S", "M", "T", "W", "T", "F", "S"][d.getDay()]}<br />{d.getDate()}</>
                      : `${String(["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][d.getDay()])} • ${d.getMonth() + 1}/${d.getDate()}`}
                  </button>

                </div>

                <div style={{ ...styles.dayColBody, flex: 1, ...(isMobile ? { padding: 2, gap: 2, minHeight: 120 } : {}) }} onClick={() => openNewForDate(d)}>
                  {spanList.map((a) => (
                    <div key={`span-${a.id}`}
                      style={{ ...styles.apptCard(a.job_type_color, a.employee_color), borderWidth: isMobile ? 1 : 2, borderRadius: isMobile ? 4 : 8, display: "flex", alignItems: "center", gap: isMobile ? 1 : 4, padding: isMobile ? 1 : "3px 4px" }}
                      onClick={(e) => { e.stopPropagation(); openEdit(a); }}>
                      {(a.isSpanMiddle || a.isSpanEnd) ? <span style={{ fontWeight: 900, flexShrink: 0, fontSize: isMobile ? 7 : undefined }}>◀</span> : null}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 900, fontSize: isMobile ? 8 : 12, lineHeight: 1.1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {(a.isSpanStart || a.isSpanEnd) ? (String(a.customer_name || "").trim() || "(customer)") : "─────"}
                        </div>
                        <div style={{ fontWeight: 800, fontSize: 11, opacity: 0.85, display: isMobile ? "none" : undefined }}>MULTI-DAY</div>
                      </div>
                      {(a.isSpanStart || a.isSpanMiddle) ? <span style={{ fontWeight: 900, flexShrink: 0, fontSize: isMobile ? 7 : undefined }}>▶</span> : null}
                    </div>
                  ))}
                  {regularList.length ? (
                    regularList.map((a) => (
                      <div key={a.id} style={{ ...styles.apptCard(a.job_type_color, a.employee_color), ...(isMobile ? { borderWidth: 1, borderRadius: 4, padding: 1 } : {}) }} onClick={(e) => { e.stopPropagation(); openEdit(a); }}>
                        <div style={{ ...styles.empStripe(a.employee_color), ...(isMobile ? { width: 3, borderRightWidth: 1 } : {}) }} />
                        <div style={{ ...styles.apptTitle, ...(isMobile ? { marginLeft: 4, fontSize: 8, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } : {}) }}>
                          {fmtTime12(a.start_time)}–{fmtTime12(a.end_time)}
                        </div>
                        <div style={{ ...styles.apptSub, ...(isMobile ? { display: "none" } : {}) }}>
                          {String(a.customer_name || "").trim() || "(customer)"}
                          {a.estimate_on_file ? " • ✅" : ""}
                        </div>
                      </div>
                    ))
                  ) : spanList.length === 0 && !isMobile ? (
                    <div style={{ fontWeight: 900, opacity: 0.85 }}>No appointments.</div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </div>
);

export default CalendarWeekView;
